<template>
  <v-navigation-drawer
      :temporary="$vuetify.breakpoint.smAndDown"
      :value="nav || $vuetify.breakpoint.mdAndUp"
      @input="$emit('update:nav', $event)"
      :mobile-break-point="960"
      :fixed="$vuetify.breakpoint.mdAndUp"
      :clipped="$vuetify.breakpoint.mdAndUp"
      app
      :class="$theme.themes.drawer"
  >
    <v-toolbar dark flat class="hidden-md-and-up" color="primary">
      <v-btn icon @click.native="$emit('update:nav', false)"><v-icon>arrow_back</v-icon></v-btn>
      <v-spacer></v-spacer>
      <slot name="platform-actions" class="platform-actions" dark></slot>
    </v-toolbar>
    <v-layout class="logo hidden-md-and-up primary">
      <img :src="loadedLogo"/>
    </v-layout>
    <template v-for="container in containers">
      <v-list v-if="container.condition ? container.condition() : true"
        :key="container.name">
        <template>
          <v-list-tile disabled class="title">
            <v-list-tile-content>
              <v-list-tile-title>
                {{$tf(container.name).toUpperCase()}}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <template v-for="item in container.items">
            <component v-if="(item.condition ? item.condition() : true) && item.item" :key="item.name" :is="item.item" />
            <v-list-tile v-else-if="(item.condition ? item.condition() : true)"
              @click="drawerAction(item)"
              :data-name="item.name"
              :key="item.name"
              :disabled="item.nav === selected"
              :class="{highlight: item.highlight}">
              <v-list-tile-avatar>
                <v-icon>{{item.icon}}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  {{$tf(item.label)}}
                </v-list-tile-title>
              </v-list-tile-content>

              <v-chip v-if="item.badge" class="text-bold grey white--text">{{item.badge()}}</v-chip>
            </v-list-tile>
          </template>
        </template>
      </v-list>
    </template>
    <v-container class="hidden-sm-and-down"></v-container>
    <v-divider class="mt-4" />
    <LastAccessInfo :isInDrawer="true" v-if="!$store.getters['session/hasGuestAuthentication']"/>
  </v-navigation-drawer>
</template>

<script>
  import IdoniaFooter from '../footer/IdoniaFooter.vue'
  import LastAccessInfo from '../common/LastAccessInfo.vue'
  import bus from '~/bus'
  export default {
    name: 'drawer',
    components: {IdoniaFooter, LastAccessInfo},
    props: {
      nav: {
        type: Boolean,
        default: false
      },
      logo: {
        type: String,
        default: ''
      },
      whitelabel: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        lastAccessTimestamp: null,
        loadedLogo: '',
        containers: [
          {
            name: 'Visualize',
            items: []
          },
          {
            name: 'My Account',
            condition: () => { return this.$store.state.config.myspacelimit },
            items: [
              { name: 'profile',
                icon: 'settings',
                label: 'Settings',
                nav: '/myaccount'
              }
            ]
          },
          {
            name: 'Administration',
            condition: () => { return false }, // this.isAdmin }, TODO new control panel
            items: [
              {
                name: 'users',
                icon: 'person',
                label: 'Accounts',
                nav: '/admin/accounts'
              },
              {
                name: 'groups',
                icon: 'people',
                label: 'Groups',
                nav: '/admin/groups'
              }
            ]
          }
        ]
      }
    },
    created () {
      if (this.$store.state.config.tags) {
        this.containers[0].items = this.containers[0].items.concat([
          {
            name: 'mio',
            icon: 'cloud',
            label: 'MIO',
            nav: '/mio',
            highlight: true
          }
        ])
      }
      if (this.$store.state.config.myspace) {
        this.containers[0].items = this.containers[0].items.concat([
          {
            name: 'myspace',
            icon: 'dns',
            label: 'MyIdonia',
            nav: '/myspace'
          },
          {
            name: 'shared',
            icon: 'group',
            label: 'SharedWithMe',
            nav: '/shared'
          },
          {
            name: 'recents',
            icon: 'access_time',
            label: 'Recents',
            nav: '/recents'
          },
          {
            name: 'starred',
            icon: 'star',
            label: 'Favorited',
            nav: '/starred'
          },
          {
            name: 'trash',
            icon: 'delete',
            label: 'Deleted',
            nav: '/trash',
            badge: () => this.totalFilesDeleted
          }
        ])
      }
    },
    mounted () {
      if (!this.$store.state.trashCount.value) {
        this.$store.dispatch('trashCount/loadElements')
      }
    },
    computed: {
      selected () {
        return this.$store.state.nav.navRoot.link
      },
      totalFilesDeleted () {
        return this.$store.state.trashCount.value
      },
      isAdmin () {
        return this.$store.state.session.isAdmin
      }
    },
    watch: {
      logo: {
        immediate: true,
        handler (val) {
          let imgWL = new Image()
          imgWL.onload = () => {
            this.loadedLogo = imgWL.src
          }
          imgWL.onerror = () => {
            let img = new Image()
            img.onload = () => {
              this.loadedLogo = img.src
            }
            img.src = val
          }
          imgWL.src = this.whitelabel + val
        }
      }
    },
    methods: {
      myAccountUrl () {
        return `${window.location.origin}/myaccount`
      },
      drawerAction (item) {
        this.$router.push(item.nav)
        bus.$emit('analytics', {
          action: `drawer-click-navigation`,
          arguments: {
            route: item.name
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  aside {
    min-height: 100%;
    z-index: 6;
  }

  .logo {
    height: 128px;
    min-width: 300px;
    max-width: 300px;
    display: flex;
    align-content: center;
    justify-content: center;
    img, object {
      max-height: 118px;
      max-width: 270px;
      margin: auto;
    }
  }

  /deep/ .toolbar__content div {
    margin: 0 !important;
  }

  .highlight {
    border-bottom: 1px dashed gray;
  }

  /deep/ .add-storage button {
    margin-left: auto;
    margin-top: 15px;
    margin-right: 40px;
  }

  /deep/ .list__tile--disabled {
    opacity: 1 !important
  }

  /deep/ .list__tile--disabled .list__tile__title {
    color: var(--primary_text) !important
  }

  /deep/ .list__tile--disabled i {
    color: var(--primary_text) !important
  }
</style>



// WEBPACK FOOTER //
// src/components/drawer/Drawer.vue